var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useQuery } from '@apollo/client';
import useScroll from 'utils/hooks/useScroll';
import { getPageInfo } from 'utils/paginationHelper';
import USERS from 'apollo/queries/USERS';
var useUsersTable = function (_a) {
    var _b;
    var filterValues = _a.filterValues, id = _a.id, containerRef = _a.containerRef;
    var _c = useQuery(USERS, {
        variables: {
            filters: __assign({ team_ids: [id] }, filterValues)
        }
    }), data = _c.data, loading = _c.loading, fetchMore = _c.fetchMore;
    var dataSource = ((_b = data === null || data === void 0 ? void 0 : data.users) === null || _b === void 0 ? void 0 : _b.nodes) || [];
    var dataPath = ['users'];
    var pageInfo = getPageInfo(dataPath)(data);
    var scrollLoading = useScroll({
        dataPath: dataPath,
        dataType: 'nodes',
        fetchMore: fetchMore,
        pageInfo: pageInfo,
        isTable: true,
        filterUniqueIds: true,
        tableId: '',
        scrollRef: containerRef,
        isHorizontalScroll: false
    }).scrollLoading;
    return {
        data: {
            loading: loading,
            users: dataSource,
            scrollLoading: scrollLoading
        }
    };
};
export default useUsersTable;
